import { useEffect, useState, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import { scroll } from "framer-motion/dom";
import { motion } from "framer-motion";
import FluidSimulation from "fluid-simulation-react";
import "./typography.css";
import NotFound from "./pages/shared/notfound/NotFound";

import LoadingBar from "react-top-loading-bar";
import {
    Navigate,
    Route,
    Routes,
    BrowserRouter as Router,
    Outlet,
    Link,
    useNavigate,
} from "react-router-dom";
import gsap from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { useGSAP } from "@gsap/react";
import { SplitText } from "gsap/SplitText";
import Home from "./pages/home/Home";
import Navbar from "./pages/shared/navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { toggleTheme } from "./redux/slices/themeSlice";
import Footer from "./pages/shared/footer/Footer";
import data from "./data";
import Scene from "./pages/shared/3d/Scene";
import Faq from "./pages/shared/faq/Faq";
import TeamTwo from "./pages/home/components/team/TeamTwo";
import MobileNavbar from "./pages/shared/navbar/MobileNavbar";
import Press from "./pages/home/components/press/Press";
import SingleProject from "./pages/home/components/art/SingleProject";
import Opening from "./pages/home/components/opening/Opening";
import Partners from "./pages/home/components/partners/Partners";
import Navigation from "./pages/shared/navbar/Navigation";

function App() {
    const [pageInView, setPageInView] = useState("");
    const [topLoadingProgress, setTopLoadingProgress] = useState(0);
    const scrollRef = useRef(null);
    const dispatch = useDispatch();
    const [isLargeScreen, setIsLargeScreen] = useState(
        window.innerWidth > 1024
    );
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isPage, setisPage] = useState(1);
    const { mode } = useSelector((state) => state.theme);
    const [isLoading, setIsLoading] = useState(true);
    const profile = JSON.parse(localStorage.getItem("profile"));
    const [pageName, setPageName] = useState("normal", "mobileNavbar");
    const [navbarVisible, setNavbarVisible] = useState(false);
    const [scrollToComponent, setScrollToComponent] = useState("scene");
    const handleSubscribe = async () => {
        Navigate("/#footer");
    };
    const handleScrollToComponent = (id) => {
        setScrollToComponent(id);
    };
    useEffect(() => {
        // When app loads, check if a theme mode is saved in localStorage
        const savedMode = localStorage.getItem("themeMode");
        if (savedMode) {
            // If found, dispatch an action to set the mode
            dispatch(toggleTheme(savedMode));
        }
    }, [dispatch]);
    // useEffect(() => {
    //     // Save the mode to localStorage whenever it changes
    //     localStorage.setItem("themeMode", mode);
    // }, [mode]);

    gsap.registerPlugin(
        ScrollTrigger,
        ScrollToPlugin,
        ScrollSmoother,
        SplitText,
        useGSAP
    );
    const scrollToElement = (id) => {
        const element = document.getElementById(id);
        console.log("clicked", id);
        if (element) {
            gsap.to(window, {
                scrollTo: {
                    y: element.offsetTop,
                    offsetY: -140, // adjust this value as needed
                },
                ease: "power2.inOut",
            });
        }
    };
    const handlePagination = (item, number) => {
        scrollToElement(item);
        setisPage(number);
    };
    useEffect(() => {
        const handleScroll = () => {
            // Calculate the current scroll progress
            const totalScroll =
                document.documentElement.scrollHeight - window.innerHeight;
            const currentScroll = window.scrollY;
            const scrollProgress = (currentScroll / totalScroll) * 100;

            // Update the loading bar's progress
            setTopLoadingProgress(scrollProgress);
        };

        // Add scroll event listener
        window.addEventListener("scroll", handleScroll);

        // Remove event listener on cleanup
        return () => window.removeEventListener("scroll", handleScroll);
    }, []); // Empty dependency array means this effect runs once on mount


    console.log("isLoading", isLoading);
    return (
        <div className={`${mode === "dark" ? "dark-mode" : "light-mode"} `}>
            <ToastContainer />
            <Router>
                {" "}
                <Routes>
                    {/*Standard......................*/}
                    <Route
                        element={
                            <div className="scroll-smooth antialiased flex flex-col min-h-screen  ">
                                {!isLoading && (
                                    <div className="w-full  fixed top-0   z-40">
                                        <div className="z-40">
                                            <LoadingBar
                                                color="white"
                                                progress={topLoadingProgress}
                                            ></LoadingBar>
                                        </div>
                                        <div className="z-40">
                                            {" "}
                                            <Navbar
                                                setPageInView={setPageInView}
                                                pageInView={pageInView}
                                                setIsLargeScreen={
                                                    setIsLargeScreen
                                                }
                                                isPage={isPage}
                                                setisPage={setisPage}
                                                isLargeScreen={isLargeScreen}
                                                data={data}
                                                setIsMenuOpen={setIsMenuOpen}
                                                isMenuOpen={isMenuOpen}
                                                setNavbarVisible={
                                                    setNavbarVisible
                                                }
                                                pageName={pageName}
                                                setPageName={setPageName}
                                                handleSubscribe={
                                                    handleSubscribe
                                                }
                                            />
                                        </div>
                                    </div>
                                )}
                                <Outlet /> <div className="flex-grow"></div>
                                {pageName !== "mobileNavbar" && !isLoading && (
                                    <div className="bottom-0" id="footer">
                                        <Footer
                                            data={data}
                                            setIsLargeScreen={setIsLargeScreen}
                                            isLargeScreen={isLargeScreen}
                                        />
                                    </div>
                                )}
                            </div>
                        }
                    >
                        {" "}
                        <Route
                            element={
                                <div className="">
                                    <Home
                                        data={data}
                                        setPageName={setPageName}
                                        pageName={pageName}
                                        navbarVisible={navbarVisible}
                                        setIsLoading={setIsLoading}
                                        isPage={isPage}
                                        setisPage={setisPage}
                                        isLoading={isLoading}
                                        setIsLargeScreen={setIsLargeScreen}
                                        isLargeScreen={isLargeScreen}
                                        setPageInView={setPageInView}
                                        pageInView={pageInView}
                                    />
                                </div>
                            }
                            path="/"
                        />
                        {/* <Route
                            element={
                                <div className="">
                                    <TeamTwo
                                        data={data}
                                        isLargeScreen={isLargeScreen}
                                        isLoading={isLoading}
                                        setIsLoading={setIsLoading}
                                    />
                                </div>
                            }
                            path="/team"
                        /> */}
    
                        <Route
                            element={
                                <div className="">
                                    <SingleProject
                                        data={data}
                                        isLoading={isLoading}
                                        setIsLoading={setIsLoading}
                                        isLargeScreen={isLargeScreen}
                                    />
                                </div>
                            }
                            path="/products/:linkRoute"
                        />
                    </Route>

                    {/*Error 404 not found......................*/}

                    <Route path="*" element={<NotFound />} />
                </Routes>{" "}
            </Router>
        </div>
    );
}

export default App;
